module.exports = __webpack_public_path__ + "static/img/kfz.218ee69.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kfz.jpeg
// module id = 1KwA
// module chunks = 171